import { heroesData } from '@/settings/heroesData';
import './leaderboardItem.css';
import { cn } from '@/ui/lib/utils';

interface LeaderboardItemProps {
    racerId: string;
    rank: number;
    betsCount: number;
    bet: boolean;
}

export const LeaderboardItem = ({ racerId, rank, betsCount, bet }: LeaderboardItemProps) => {
    return (
        <div className={cn('leaderboard-item', bet && 'leaderboard-item--bet')}>
            <div className="leaderboard-item__left">
                <div className={`leaderboard-item__rank leaderboard-item__rank--${rank}`}>
                    {rank}
                </div>

                <div className="leaderboard-item__avatar">
                    <img src={`assets/images/${racerId}.png`} alt={racerId} />
                </div>

                <div className="leaderboard-item__name">{heroesData[racerId]?.name ?? racerId}</div>
            </div>

            <div className="leaderboard-item__bet-count">{betsCount}</div>
        </div>
    );
};
